import { Navigate, createFileRoute, useParams, useRouterState } from '@tanstack/react-router';
import { legacyFeedTarget } from '../lib/feed-search.js';

/** The workspace-scoped half of the legacy /notifications redirect; see `./notifications.tsx`. */
export const Route = createFileRoute('/$workspaceSlug/notifications')({
  component: LegacyWorkspaceNotificationsRedirect,
});

export function LegacyWorkspaceNotificationsRedirect() {
  const { workspaceSlug } = useParams({ from: '/$workspaceSlug/notifications' });
  const search = useRouterState({ select: (state) => state.location.searchStr });
  const target: string = legacyFeedTarget(search, workspaceSlug);
  return <Navigate to={target} replace />;
}
